"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebouncedCallback = void 0;
const lodash_1 = require("lodash");
const react_1 = require("react");
/**
 * A React hook which applies lodash.debounce to a function correctly.
 * The wrapped function will be invoked only after `wait` milliseconds
 * have passed since the last invocation of the returned function.
 * On dismount, if there are pending invocations, they are flushed.
 *
 * @param fn The function to debounce.
 * @param wait The number of milliseconds to delay.
 */
const useDebouncedCallback = (fn, wait) => {
    // Memoizing with [] ensures these are only run when the component mounts or dismounts
    const debounced = (0, react_1.useCallback)((0, lodash_1.debounce)(fn, wait, { trailing: true }), []);
    // No-op effect which returns flush for cleanup
    (0, react_1.useEffect)(() => debounced.flush, []);
    return debounced;
};
exports.useDebouncedCallback = useDebouncedCallback;
//# sourceMappingURL=useDebouncedCallback.js.map